import { DATE_FORMAT } from '../../../constants/service/common/utilConstants';
import {
  DELIVERY_INFO_MODIFY_TYPE,
  ORDER_DELIVERY_TYPE,
  ORDER_ITEM_PERIOD_SEARCH_TYPE,
} from '../../../constants/service/app/orderConstants';
import moment, { setDateFormat } from '../../../lib/moment';
import { _LIST_PAGINATION_MODEL } from '../app/models';

/**
 *  주문 집계 모델
 */
export const ORDER_SUMMARY_BOX_MODEL = {
  /**
   *  판매금액
   */
  salesAmount: null,
  /**
   *  실 판매금액
   */
  actualSalesAmount: null,
  /**
   *  사용된 포인트
   */
  usedPointAmount: null,
  /**
   *  사용된 쿠폰
   */
  usedCouponAmount: null,
  /**
   *  주문서 작성 건수
   */
  createOrderCnt: null,
  /**
   *  주문 건수
   */
  totalOrderCnt: null,
  /**
   *  상품 주문 건수
   */
  totalOrderItemCnt: null,
  /**
   *  상품 주문 취소 건수
   */
  orderItemCancelCnt: null,
  /**
   *  상품 주문 반품 건수
   */
  orderItemReturnCnt: null,
  /**
   *  상품 주문 교환 건수
   */
  orderItemExchangeCnt: null,
  /**
   *  상품 구매 수량
   */
  totalPurchaseQuantity: null,
};

/**
 *  주문 전체 리스트 검색 박스 모델
 */
export const ORDER_ALL_LIST_SEARCH_DATA_MODEL = {
  /**
   *  주문 일시
   */
  orderDate: {
    /**
     *  빠른 날짜 선택 값
     */
    quickDateIndex: 0,
    period: {
      startDate: setDateFormat(moment(), DATE_FORMAT.YMD_DASH_FORMAT),
      endDate: setDateFormat(moment(), DATE_FORMAT.YMD_DASH_FORMAT),
    },
  },
  /**
   *  상품 주문 상태 리스트
   */
  orderItemStatusList: [],
};

/**
 *  주문 전체 리스트 검색 옵션 모델
 */
export const ORDER_ALL_LIST_SEARCH_OPTION_MODEL = {
  /**
   *  주문 일시
   */
  orderDate: {
    startDate: setDateFormat(moment(), DATE_FORMAT.YMD_DASH_FORMAT),
    endDate: setDateFormat(moment(), DATE_FORMAT.YMD_DASH_FORMAT),
  },
  /**
   *  상품 주문 상태 리스트
   */
  orderItemStatusList: [],
};

/**
 *  주문 전체 리스트 필터 옵션 모델
 */
export const ORDER_ALL_LIST_FILTER_OPTION_MODEL = {
  /**
   *  주문번호 ID
   */
  orderId: null,
  /**
   *  상품 주문번호 ID
   */
  orderItemId: null,
  /**
   *  브랜드명
   */
  brandName: null,
  /**
   *  브랜드 ID
   */
  storeId: null,
  /**
   *  브랜드 ID 리스트
   */
  storeIdList: null,
  /**
   *  송장 번호
   */
  invoiceNumber: null,
  /**
   *  결제 일시
   */
  paymentDate: {
    startDate: null,
    endDate: null,
  },
  /**
   *  상품 준비 일시
   */
  deliveryPrepareDate: {
    startDate: null,
    endDate: null,
  },
  /**
   *  발송 처리 일시
   */
  deliveryDispatchDate: {
    startDate: null,
    endDate: null,
  },
  /**
   *  배송 완료 일시
   */
  deliveryCompleteDate: {
    startDate: null,
    endDate: null,
  },
  /**
   *  상품번호
   */
  productId: null,
  /**
   *  상품명
   */
  productName: null,
  /**
   *  제품 번호
   */
  productNumber: null,
  /**
   *  옵션 제품 번호
   */
  productOptionNumber: null,
  /**
   *  상품 1차 카테고리
   */
  mainCategory: null,
  /**
   *  상품 2차 카테고리
   */
  subCategory: null,
  /**
   *  구매자 연락처
   */
  buyerPhone: null,
  /**
   *  수취인 연락처
   */
  recipientPhone: null,
  /**
   *  수취인명
   */
  recipientName: null,
  /**
   *  결제수단
   */
  payMethod: null,
  /**
   *  주문 타입
   */
  orderType: null,
  /**
   *  선물 상태
   */
  giftStatus: null,
};

/**
 *  주문 전체 리스트 필터 옵션 모델
 */
export const ORDER_ALL_LIST_SORT_OPTION_MODEL = [
  {
    id: 'paymentDate',
    desc: true,
  },
];

/**
 *  주문 취소 집계 모델
 */
export const ORDER_CANCEL_SUMMARY_BOX_MODEL = {
  /**
   *  입금 기한 초과 건수
   */
  depositExpiredCnt: null,
  /**
   *  입금 기한 초과 합계 금액
   */
  depositExpiredTotalPrice: null,
  /**
   *  취소 요청 건수
   */
  cancelRequestCnt: null,
  /**
   *  취소 요청 건수 합계 금액
   */
  cancelRequestTotalPrice: null,
  /**
   *  취소 거부 건수
   */
  cancelRejectCnt: null,
  /**
   *  취소 거부 건수 합계 금액
   */
  cancelRejectTotalPrice: null,
  /**
   *  취소 완료 건수
   */
  cancelCompleteCnt: null,
  /**
   *  취소 완료 건수 합계 금액
   */
  cancelCompleteTotalPrice: null,
  /**
   *  환불 완료 건수
   */
  refundDoneCnt: null,
  /**
   *  환불 완료 건수 합계 금액
   */
  refundDoneTotalPrice: null,
};

/**
 *  취소 내역 리스트 검색 박스 모델
 */
export const ORDER_CANCEL_LIST_SEARCH_DATA_MODEL = {
  /**
   *  취소 요청 일시
   */
  canceledDate: {
    /**
     *  빠른 날짜 선택 값
     */
    quickDateIndex: 0,
    period: {
      startDate: setDateFormat(moment(), DATE_FORMAT.YMD_DASH_FORMAT),
      endDate: setDateFormat(moment(), DATE_FORMAT.YMD_DASH_FORMAT),
    },
  },
  /**
   *  상품 주문 취소 상태 리스트
   */
  orderCancelStatusList: [],
  /**
   *  취소 접수자 리스트
   */
  cancelAcceptManagerList: [],
  /**
   *  취소 처리자 리스트
   */
  cancelManagerList: [],
};

/**
 *  취소 내역 리스트 검색 옵션 모델
 */
export const ORDER_CANCEL_LIST_SEARCH_OPTION_MODEL = {
  /**
   *  취소 요청 일시
   */
  canceledDate: {
    startDate: setDateFormat(moment(), DATE_FORMAT.YMD_DASH_FORMAT),
    endDate: setDateFormat(moment(), DATE_FORMAT.YMD_DASH_FORMAT),
  },
  /**
   *  상품 주문 취소 상태 리스트
   */
  orderCancelStatusList: [],
  /**
   *  취소 접수자 리스트
   */
  cancelAcceptManagerList: [],
  /**
   *  취소 처리자 리스트
   */
  cancelManagerList: [],
};

/**
 *  주문 취소 리스트 필터 옵션 모델
 */
export const ORDER_CANCEL_LIST_FILTER_OPTION_MODEL = {
  /**
   *  주문번호 ID
   */
  orderId: null,
  /**
   *  상품 주문번호 ID
   */
  orderItemId: null,
  /**
   *  브랜드명
   */
  brandName: null,
  /**
   *  브랜드 ID
   */
  storeId: null,
  /**
   *  상품 주문 취소 상태
   */
  orderCancelStatus: null,
  /**
   *  결제 일시
   */
  paymentDate: {
    startDate: null,
    endDate: null,
  },
  /**
   *  주문 일시
   */
  orderDate: {
    startDate: null,
    endDate: null,
  },
  /**
   *  취소처리 일시
   */
  canceledDate: {
    startDate: null,
    endDate: null,
  },
  /**
   *  취소완료 일시
   */
  cancelCompleteDate: {
    startDate: null,
    endDate: null,
  },
  /**
   *  상품번호
   */
  productId: null,
  /**
   *  상품명
   */
  productName: null,
  /**
   *  상품 1차 카테고리
   */
  mainCategory: null,
  /**
   *  상품 2차 카테고리
   */
  subCategory: null,
  /**
   *  유저 식별 ID
   */
  userId: null,
  /**
   *  구매자 ID
   */
  buyerAccount: null,
  /**
   *  구매자명
   */
  buyerName: null,
  /**
   *  구매자 연락처
   */
  buyerPhone: null,
  /**
   *  수취인 연락처
   */
  recipientPhone: null,
  /**
   *  수취인명
   */
  recipientName: null,
  /**
   *  결제수단
   */
  payMethod: null,
  /**
   *  주문 타입
   */
  orderType: null,
  /**
   *  선물 상태
   */
  giftStatus: null,
};

/**
 *  주문 취소 리스트 필터 옵션 모델
 */
export const ORDER_CANCEL_LIST_SORT_OPTION_MODEL = [
  {
    id: 'paymentDate',
    desc: true,
  },
];

/**
 *  주문 반품 집계 모델
 */
export const ORDER_RETURN_SUMMARY_BOX_MODEL = {
  /**
   *  반품 요청 건수
   */
  returnRequestCnt: null,
  /**
   *  반품 요청 합계 금액
   */
  returnRequestTotalPrice: null,
  /**
   *  반품 수거 완료 건수
   */
  returnReceiveCnt: null,
  /**
   *  반품 수거 완료 금액
   */
  returnReceiveTotalPrice: null,
  /**
   *  반품 처리 지연 건수
   */
  returnDelayCnt: null,
  /**
   *  반품 처리 지연 금액
   */
  returnDelayTotalPrice: null,
  /**
   *  반품 거부 건수
   */
  returnRejectCnt: null,
  /**
   *  반품 거부 합계 금액
   */
  returnRejectTotalPrice: null,
  /**
   *  반품 승인 건수
   */
  returnCompleteCnt: null,
  /**
   *  반품 승인 합계 금액
   */
  returnCompleteTotalPrice: null,
  /**
   *  반품 완료 건수
   */
  refundCompleteCnt: null,
  /**
   *  반품 완료 합계 금액
   */
  refundCompleteTotalPrice: null,
};

/**
 *  반품 내역 리스트 검색 박스 모델
 */
export const ORDER_RETURN_LIST_SEARCH_DATA_MODEL = {
  /**
   *  반품 요청 일시
   */
  returnRequestDate: {
    /**
     *  빠른 날짜 선택 값
     */
    quickDateIndex: 0,
    period: {
      startDate: setDateFormat(moment(), DATE_FORMAT.YMD_DASH_FORMAT),
      endDate: setDateFormat(moment(), DATE_FORMAT.YMD_DASH_FORMAT),
    },
  },
  /**
   *  상품 주문 반품 상태 리스트
   */
  orderReturnStatusList: [],
  /**
   *  반품 접수자 리스트
   */
  returnAcceptManagerList: [],
};

/**
 *  반품 내역 리스트 검색 옵션 모델
 */
export const ORDER_RETURN_LIST_SEARCH_OPTION_MODEL = {
  /**
   *  취소 요청 일시
   */
  returnRequestDate: {
    startDate: setDateFormat(moment(), DATE_FORMAT.YMD_DASH_FORMAT),
    endDate: setDateFormat(moment(), DATE_FORMAT.YMD_DASH_FORMAT),
  },
  /**
   *  상품 주문 반품 상태 리스트
   */
  orderReturnStatusList: [],
  /**
   *  반품 접수자 리스트
   */
  returnAcceptManagerList: [],
};

/**
 *  주문 교환 집계 모델
 */
export const ORDER_EXCHANGE_SUMMARY_BOX_MODEL = {
  /**
   *  교환 요청 건수
   */
  exchangeRequestCnt: null,
  /**
   *  교환 요청 합계 금액
   */
  exchangeRequestTotalPrice: null,
  /**
   *  교환 수거 완료 건수
   */
  exchangeReceiveCnt: null,
  /**
   *  교환 수거 완료 금액
   */
  exchangeReceiveTotalPrice: null,
  /**
   *  교환 처리 지연 건수
   */
  exchangeDelayCnt: null,
  /**
   *  교환 처리 지연 금액
   */
  exchangeDelayTotalPrice: null,
  /**
   *  교환 거부 건수
   */
  exchangeRejectCnt: null,
  /**
   *  교환 거부 합계 금액
   */
  exchangeRejectTotalPrice: null,
  /**
   *  교환품 재배송 건수
   */
  exchangeDispatchCnt: null,
  /**
   *  교환품 재배송 합계 금액
   */
  exchangeDispatchTotalPrice: null,
  /**
   *  교환 완료 건수
   */
  exchangeCompleteCnt: null,
  /**
   *  교환 완료 합계 금액
   */
  exchangeCompleteTotalPrice: null,
};

/**
 *  교환 내역 리스트 검색 박스 모델
 */
export const ORDER_EXCHANGE_LIST_SEARCH_DATA_MODEL = {
  /**
   *  교환 요청 일시
   */
  exchangeRequestDate: {
    /**
     *  빠른 날짜 선택 값
     */
    quickDateIndex: 0,
    period: {
      startDate: setDateFormat(moment(), DATE_FORMAT.YMD_DASH_FORMAT),
      endDate: setDateFormat(moment(), DATE_FORMAT.YMD_DASH_FORMAT),
    },
  },
  /**
   *  상품 주문 교환 상태 리스트
   */
  orderExchangeStatusList: [],
  /**
   *  교환 접수자 리스트
   */
  exchangeAcceptManagerList: [],
};

/**
 *  교환 내역 리스트 검색 옵션 모델
 */
export const ORDER_EXCHANGE_LIST_SEARCH_OPTION_MODEL = {
  /**
   *  취소 요청 일시
   */
  exchangeRequestDate: {
    startDate: setDateFormat(moment(), DATE_FORMAT.YMD_DASH_FORMAT),
    endDate: setDateFormat(moment(), DATE_FORMAT.YMD_DASH_FORMAT),
  },
  /**
   *  상품 주문 교환 상태 리스트
   */
  orderExchangeStatusList: [],
  /**
   *  교환 접수자 리스트
   */
  exchangeAcceptManagerList: [],
};

/**
 *  주문 교환 리스트 필터 옵션 모델
 */
export const ORDER_EXCHANGE_LIST_FILTER_OPTION_MODEL = {
  /**
   *  주문번호 ID
   */
  orderId: null,
  /**
   *  상품 주문번호 ID
   */
  orderItemId: null,
  /**
   *  교환 처리 상태
   */
  orderExchangeStatus: null,
  /**
   *  교환 배송 송장 번호
   */
  invoiceNumber: null,
  /**
   *  결제 일시
   */
  paymentDate: {
    startDate: null,
    endDate: null,
  },
  /**
   *  교환 요청 일시
   */
  exchangeRequestDate: {
    startDate: null,
    endDate: null,
  },
  /**
   *  교환품 수거 일시
   */
  exchangeReceiveDate: {
    startDate: null,
    endDate: null,
  },
  /**
   *  교환품 발송 처리 일시
   */
  deliveryDispatchDate: {
    startDate: null,
    endDate: null,
  },
  /**
   *  교환품 배송 완료 일시
   */
  deliveryCompleteDate: {
    startDate: null,
    endDate: null,
  },
  /**
   *  브랜드명
   */
  brandName: null,
  /**
   *  브랜드 ID
   */
  storeId: null,
  /**
   *  상품번호
   */
  productId: null,
  /**
   *  상품명
   */
  productName: null,
  /**
   *  상품 1차 카테고리
   */
  mainCategory: null,
  /**
   *  상품 2차 카테고리
   */
  subCategory: null,
  /**
   *  구매자 ID
   */
  buyerAccount: null,
  /**
   *  구매자명
   */
  buyerName: null,
  /**
   *  교환품 구매자 연락처
   */
  exchangeBuyerPhone: null,
  /**
   *  수취인명
   */
  recipientName: null,
  /**
   *  교환품 수취인 연락처
   */
  exchangeRecipientPhone: null,
  /**
   *  결제수단
   */
  payMethod: null,
  /**
   *  주문 타입
   */
  orderType: null,
  /**
   *  선물 상태
   */
  giftStatus: null,
};

/**
 *  주문 교환 리스트 필터 옵션 모델
 */
export const ORDER_EXCHANGE_LIST_SORT_OPTION_MODEL = [
  {
    id: 'exchangeRequestDate',
    desc: true,
  },
];

/**
 *  주문 반품 리스트 필터 옵션 모델
 */
export const ORDER_RETURN_LIST_FILTER_OPTION_MODEL = {
  /**
   *  주문번호 ID
   */
  orderId: null,
  /**
   *  상품 주문번호 ID
   */
  orderItemId: null,
  /**
   *  반품 처리 상태
   */
  orderReturnStatus: null,
  /**
   *  반품 사유
   */
  returnType: null,
  /**
   *  결제 일시
   */
  paymentDate: {
    startDate: null,
    endDate: null,
  },
  /**
   *  반품 요청 일시
   */
  returnRequestDate: {
    startDate: null,
    endDate: null,
  },
  /**
   *  반품 수거 일시
   */
  returnReceiveDate: {
    startDate: null,
    endDate: null,
  },
  /**
   *  반품 승인 일시
   */
  returnCompleteDate: {
    startDate: null,
    endDate: null,
  },
  /**
   *  반품 완료 일시
   */
  refundCompleteDate: {
    startDate: null,
    endDate: null,
  },
  /**
   *  브랜드명
   */
  brandName: null,
  /**
   *  브랜드 ID
   */
  storeId: null,
  /**
   *  상품번호
   */
  productId: null,
  /**
   *  상품명
   */
  productName: null,
  /**
   *  상품 1차 카테고리
   */
  mainCategory: null,
  /**
   *  상품 2차 카테고리
   */
  subCategory: null,
  /**
   *  구매자 ID
   */
  buyerAccount: null,
  /**
   *  구매자명
   */
  buyerName: null,
  /**
   *  구매자 연락처
   */
  buyerPhone: null,
  /**
   *  수취인명
   */
  recipientName: null,
  /**
   *  수취인 연락처
   */
  recipientPhone: null,
  /**
   *  결제수단
   */
  payMethod: null,
  /**
   *  주문 타입
   */
  orderType: null,
  /**
   *  선물 상태
   */
  giftStatus: null,
};

/**
 *  주문 반품 리스트 필터 옵션 모델
 */
export const ORDER_RETURN_LIST_SORT_OPTION_MODEL = [
  {
    id: 'returnRequestDate',
    desc: true,
  },
];

/**
 *  주문/배송관리 리스트 검색 옵션 모델
 */
export const ORDER_MANAGEMENT_LIST_SEARCH_OPTION_MODEL = {
  /**
   *  상품 주문 상태 리스트
   */
  orderItemStatusList: [],
  /**
   *  택배 배송 방법
   */
  deliveryType: null,
  /**
   *  상세 검색
   */
  orderItemDetailSearch: {
    type: null,
    value: null,
  },
  /**
   *  상품 타입
   */
  productType: [],
  /**
   *  판매처
   */
  store: [],
  /**
   *  조회 기간
   */
  viewPeriod: {
    type: ORDER_ITEM_PERIOD_SEARCH_TYPE.PAID_DATE,
    quickDateIndex: 7,
    period: {
      startDate: setDateFormat(moment().subtract(30, 'days').startOf('day'), DATE_FORMAT.FULL_DASH_FORMAT),
      endDate: setDateFormat(moment().endOf('day'), DATE_FORMAT.FULL_DASH_FORMAT),
    },
  },
  /**
   *  주문 타입
   */
  orderTypeList: [],
  /**
   *  선물 상태
   */
  giftStatusList: [],
};

/**
 *  주문/배송관리 리스트 필터 옵션 모델
 */
export const ORDER_MANAGEMENT_LIST_FILTER_OPTION_MODEL = {
  /**
   *  배송비 변경 이력 여부
   */
  modifiedDeliveryInfo: [DELIVERY_INFO_MODIFY_TYPE.YES, DELIVERY_INFO_MODIFY_TYPE.NO],
  /**
   *  상품명
   */
  productName: null,
  /**
   *  옵션명
   */
  productOption: null,
};

/**
 *  주문/배송관리 리스트 모델
 */
export const ORDER_MANAGEMENT_LIST_MODEL = {
  /**
   *  리스트
   */
  list: [],
  /**
   *  검색 박스
   */
  searchData: ORDER_MANAGEMENT_LIST_SEARCH_OPTION_MODEL,
  /**
   *  검색 옵션
   */
  searchOption: ORDER_MANAGEMENT_LIST_SEARCH_OPTION_MODEL,
  /**
   *  필터 옵션
   */
  filterOption: ORDER_MANAGEMENT_LIST_FILTER_OPTION_MODEL,
  /**
   *  리스트 pagination
   */
  pagination: _LIST_PAGINATION_MODEL,
  /**
   *  택배사 리스트
   */
  deliveryAgentList: [],
  /**
   *  송장정보 일괄입력
   */
  registerDeliveryInfo: {
    /**
     *  배송방법 선택
     */
    deliveryType: ORDER_DELIVERY_TYPE.PARCEL_DELIVERY,
    /**
     *  택배사 선택
     */
    deliveryAgentId: null,
    /**
     *  송장번호
     */
    invoiceNumber: null,
  },
  /**
   *  선택된 상품 주문 리스트
   */
  selectedOrderItemList: [],
};

/**
 *  주문 정보 모델
 */
export const ORDER_INFO_MODEL = {
  /**
   * 주문 상세 정보
   */
  /**
   *  상품 주문번호 ID
   */
  orderItemId: null,
  /**
   *  주문번호 ID
   */
  orderId: null,
  /**
   *  상품 주문 상태
   */
  orderItemStatus: null,
  /**
   *  유저 ID
   */
  userId: null,
  /**
   *  구매자 ID
   */
  buyerAccount: null,
  /**
   *  구매자명
   */
  buyerName: null,
  /**
   *  구매자 연락처
   */
  buyerPhone: null,
  /**
   *  결제수단
   */
  payMethod: null,
  /**
   *  주문 타입
   */
  orderType: null,
  /**
   *  선물 상태
   */
  giftStatus: null,

  /**
   *  연관된 상품 주문 정보
   */
  associateOrderInfoList: [],

  /**
   * 배송지 정보
   */
  /**
   *  수취인명
   */
  recipientName: null,
  /**
   *  수취인 연락처
   */
  recipientPhone: null,
  /**
   *  배송 상세 상태
   */
  deliveryStatus: null,
  /**
   *  택배사
   */
  deliveryEnterprise: null,
  /**
   *  송장번호
   */
  invoiceNumber: null,
  /**
   *  배송정보 ID
   */
  deliveryId: null,
  /**
   *  배송 방법
   */
  deliveryType: null,
  /**
   *  배송 지연 타입
   */
  deliveryDelayType: null,
  /**
   *  배송 지연 사유
   */
  deliveryDelayReason: null,
  /**
   *  배송지 우편번호
   */
  postCode: null,
  /**
   *  배송지 주소
   */
  address: null,
  /**
   *  배송 메모
   */
  message: null,

  /**
   * 구매 상품 정보
   */
  /**
   *  브랜드 id
   */
  storeId: null,
  /**
   *  브랜드명
   */
  storeName: null,
  /**
   *  브랜드 연락처
   */
  storePhone: null,
  /**
   *  판매자 id
   */
  sellerId: null,
  /**
   *  판매자명
   */
  sellerName: null,
  /**
   *  판매자 연락처
   */
  sellerPhone: null,
  /**
   *  상품번호
   */
  productId: null,
  /**
   *  상품명
   */
  productName: null,
  /**
   *  옵션정보
   */
  productOptionName: null,
  /**
   *  관리처
   */
  management: null,
  /**
   *  타입
   */
  productManagementType: null,
  /**
   *  수량
   */
  quantity: null,
  /**
   *  상품 가격(정가)
   */
  productOriginalPrice: null,
  /**
   *  상품 할인액(차감된 금액)
   */
  productDiscountPrice: null,
  /**
   *  옵션 가격
   */
  productOptionPrice: null,
  /**
   *  사용된 쿠폰의 할인 가격
   */
  usedCoupon: null,
  /**
   *  Apoint
   */
  usedPoint: null,
  /**
   *  상품별 총 주문금액
   */
  totalPrice: null,
  /**
   *  추가 배송비
   */
  deliveryExtraFee: null,

  /**
   * 주문 처리 이력
   */
  /**
   *  주문 일시
   */
  orderDate: null,
  /**
   *  결제 일시
   */
  paymentDate: null,
  /**
   *  상품 준비 일시
   */
  deliveryPrepareDate: null,
  /**
   *  발송 처리 일시
   */
  deliveryDispatchDate: null,
  /**
   *  배송 완료 일시
   */
  deliveryCompleteDate: null,
  /**
   *  구매 확정 일시
   */
  purchaseConfirmDate: null,
  /**
   * 주문 처리 이력
   */
  orderProcessingHistory: [],

  /**
   * 사용한 쿠폰 정보
   */
  /**
   *  쿠폰 ID
   */
  couponId: null,
  /**
   *  쿠폰명
   */
  couponName: null,
  /**
   *  쿠폰에 대한 설명
   */
  couponDescription: null,
  /**
   *  쿠폰에 대한 메모
   */
  couponMemo: null,
  /**
   *  쿠폰 유형
   */
  couponAvailableType: null,
  /**
   *  쿠폰의 할인 타입
   */
  couponDiscountType: null,
  /**
   *  할인 타입에 따른 혜택 수치
   */
  couponDiscountAmount: null,
  /**
   *  최소 구매 금액
   */
  couponMinimumPurchasePrice: null,
  /**
   *  최대 할인 가능 금액
   */
  couponMaxDiscountPrice: null,
  /**
   *  쿠폰의 기간 타입
   */
  couponPeriodType: null,
  /**
   *  쿠폰 유효기간
   */
  couponPeriod: {
    startDate: null,
    endDate: null,
  },
  /**
   *  실제 쿠폰 유효기간
   */
  couponGeneratedPeriod: {
    startDate: null,
    endDate: null,
  },
  /**
   *  시작일로부터 +며칠 인지
   */
  couponDayPlus: null,
  /**
   *  쿠폰 발급 날짜
   */
  couponGeneratedDate: null,
  /**
   *  쿠폰 사용 날짜
   */
  couponUseDate: null,

  /**
   *  CS 메모정보
   */
  /**
   *  CS 리스트
   */
  orderItemCsList: [],
};

/**
 *  주문 반품 이력 모델
 */
export const ORDER_RETURN_HISTORY_MODEL = {
  /**
   *  반품 처리 상태
   */
  orderReturnStatus: null,
  /**
   *  반품 타입
   */
  returnType: null,
  /**
   *  반품 사유
   */
  returnReason: null,
  /**
   *  접수자
   */
  acceptManager: null,
  /**
   *  반품 완료 처리자
   */
  refundManager: null,
  /**
   *  반품 사유 수정 일시
   */
  returnReasonModifyDate: null,
  /**
   *  반품 거부 사유
   */
  rejectReason: null,
  /**
   *  반품 거부 일시
   */
  rejectDate: null,
  /**
   *  구매자 부담 추가배송비
   */
  buyerDeliveryExtraFee: null,
  /**
   *  판매자 부담 추가배송비
   */
  sellerDeliveryExtraFee: null,
  /**
   *  고객 부담 반품배송비
   */
  returnDeliveryFee: null,
  /**
   *  구매자 환불 예정 금액
   */
  refundExpectAmount: null,
  /**
   *  판매자 환불 예정 금액
   */
  refundSellerAmount: null,
  /**
   *  추가 청구비
   */
  refundExtraFee: null,
  /**
   *  반품 승인 책정 사유
   */
  returnCompleteReason: null,
  /**
   *  실제 고객 환불금액
   */
  refundActualAmount: null,
  /**
   *  반품 완료 책정 사유
   */
  refundCompleteReason: null,
  /**
   *  관리자 메모
   */
  adminMemo: null,
  /**
   *  판매자 정산 예정금액
   */
  sellerExpectBalanceAmount: null,
  /**
   *  반품 요청 일시
   */
  returnRequestDate: null,
  /**
   *  반품 수거 완료 일시
   */
  returnReceiveDate: null,
  /**
   *  반품 처리 지연 일시
   */
  returnDelayDate: null,
  /**
   *  반품 거부 일시
   */
  returnRejectDate: null,
  /**
   *  반품 승인 일시
   */
  returnCompleteDate: null,
  /**
   *  반품 완료 일시
   */
  refundCompleteDate: null,
  /**
   *  주문 반품 이력
   */
  orderReturnHistory: [],
};

/**
 *  주문 교환 이력 모델
 */
export const ORDER_EXCHANGE_HISTORY_MODEL = {
  /**
   *  교환 처리 상태
   */
  orderExchangeStatus: null,
  /**
   *  교환 타입
   */
  exchangeType: null,
  /**
   *  교환 사유
   */
  changeReason: null,
  /**
   *  접수자
   */
  acceptManager: null,
  /**
   *  교환처리자
   */
  changeManager: null,
  /**
   *  교환 거부 사유
   */
  rejectReason: null,
  /**
   *  교환 거부 일시
   */
  rejectDate: null,
  /**
   *  교환 사유 수정 일시
   */
  exchangeReasonModifyDate: null,
  /**
   *  교환 배송 방법
   */
  deliveryType: null,
  /**
   *  교환 배송 택배사
   */
  deliveryEnterprise: null,
  /**
   *  교환 배송 송장 번호
   */
  invoiceNumber: null,
  /**
   *  교환 요청 일시
   */
  exchangeRequestDate: null,
  /**
   *  교환품 수거 일시
   */
  exchangeReceiveDate: null,
  /**
   *  교환 처리 지연 일시
   */
  exchangeDelayDate: null,
  /**
   *  교환품 발송 처리 일시
   */
  deliveryDispatchDate: null,
  /**
   *  교환품 배송 완료 일시
   */
  deliveryCompleteDate: null,
  /**
   *  수취인명
   */
  recipientName: null,
  /**
   *  교환시 수취인 연락처
   */
  exchangeRecipientPhone: null,
  /**
   *  교환시 배송지
   */
  address: null,
  /**
   *  교환시 우편번호
   */
  postCode: null,
  /**
   *  교환시 배송메시지
   */
  message: null,
  /**
   *  주문 교환 이력
   */
  orderExchangeHistory: [],
};

/**
 *  주문 후기 내역 모델
 */
export const ORDER_REVIEW_INFO_MODEL = {
  /**
   *  상품 후기 식별 id
   */
  reviewId: null,
  /**
   *  상품 후기 이미지 리스트
   */
  attachments: null,
  /**
   *  상품 후기 별점
   */
  rate: null,
  /**
   *  상품 후기 작성일
   */
  createDate: null,
  /**
   *  상품 주문 구매자 id
   */
  buyerId: null,
  /**
   *  유저 식별 id
   */
  userId: null,
  /**
   * 상품 주문 구매자명
   */
  buyerName: null,
  /**
   *  상품 후기 내용
   */
  content: null,
  /**
   *  상품 후기 상태
   */
  status: null,
  /**
   *  상품 주문 번호
   */
  orderItemId: null,
};

/**
 *  주문 정산 내역 모델
 */
export const ORDER_BALANCE_INFO_MODEL = {
  /**
   *  정산번호
   */
  balanceId: null,
  /**
   *  브랜드명
   */
  brandName: null,
  /**
   *  정산 기준일
   */
  baseDate: null,
  /**
   *  정산 예정일
   */
  dueDate: null,
  /**
   *  정산 상태
   */
  status: null,
  /**
   *  정산 완료일
   */
  completeDate: null,
  /**
   *  총 결제금액
   */
  totalPrice: null,
};

/**
 *  주문 반품 상세 모델
 */
export const ORDER_RETURN_DETAIL_MODEL = {
  /**
   *  주문번호 ID
   */
  orderId: null,
  /**
   *  상품 주문번호 ID
   */
  orderItemId: null,
  /**
   *  연관된 상품 주문 정보
   */
  associateOrderInfoList: [],
  /**
   *  상품번호
   */
  productId: null,
  /**
   *  상품명
   */
  productName: null,
  /**
   *  상품별 총 주문금액
   */
  totalPrice: null,
  /**
   *  반품 타입
   */
  returnType: null,
  /**
   *  반품 사유
   */
  returnReason: null,
  /**
   *  구매자 부담 추가배송비
   */
  buyerDeliveryExtraFee: null,
  /**
   *  판매자 부담 추가배송비
   */
  sellerDeliveryExtraFee: null,
  /**
   *  고객 부담 반품배송비
   */
  returnDeliveryFee: null,
  /**
   *  구매자 환불 예정 금액
   */
  refundExpectAmount: null,
  /**
   *  판매자 환불 예정 금액
   */
  refundSellerAmount: null,
  /**
   *  추가 청구비
   */
  refundExtraFee: null,
  /**
   *  반품 승인 책정 사유
   */
  returnCompleteReason: null,
  /**
   *  실제 고객 환불금액
   */
  refundActualAmount: null,
  /**
   *  반품 완료 책정 사유
   */
  refundCompleteReason: null,
  /**
   *  관리자 메모
   */
  adminMemo: null,
  /**
   *  판매자 정산 예정금액
   */
  sellerExpectBalanceAmount: null,
  /**
   *  결제수단
   */
  payMethod: null,
  /**
   *  (결제수단이 가상계좌일 때)구매자가 환불받을 은행명
   */
  bankName: null,
  /**
   *  (결제수단이 가상계좌일 때)구매자가 환불받을 계좌번호
   */
  bankNumber: null,
  /**
   *  (결제수단이 가상계좌일 때)구매자가 환불받을 예금주
   */
  bankHolder: null,
  /**
   *  반품 완료한 adminName
   */
  adminName: null,
};

/**
 *  취소 관리 리스트 검색 박스 모델
 */
export const ORDER_CANCEL_MANAGEMENT_LIST_SEARCH_DATA_MODEL = {
  /**
   *  취소 요청 일시
   */
  canceledDate: {
    /**
     *  빠른 날짜 선택 값
     */
    quickDateIndex: 0,
    period: {
      startDate: setDateFormat(moment(), DATE_FORMAT.YMD_DASH_FORMAT),
      endDate: setDateFormat(moment(), DATE_FORMAT.YMD_DASH_FORMAT),
    },
  },
  /**
   *  상품 주문 취소 상태 리스트
   */
  orderCancelStatusList: [],
  /**
   *  취소 접수자 리스트
   */
  cancelAcceptManagerList: [],
  /**
   *  취소 처리자 리스트
   */
  cancelManagerList: [],
  /**
   *  상세 검색
   */
  orderItemDetailSearch: {
    type: null,
    value: null,
  },
  /**
   *  상품 타입
   */
  productType: [],
  /**
   *  판매처
   */
  store: [],
};

/**
 *  취소 관리 리스트 검색 옵션 모델
 */
export const ORDER_CANCEL_MANAGEMENT_LIST_SEARCH_OPTION_MODEL = {
  /**
   *  취소 요청 일시
   */
  canceledDate: {
    startDate: setDateFormat(moment(), DATE_FORMAT.YMD_DASH_FORMAT),
    endDate: setDateFormat(moment(), DATE_FORMAT.YMD_DASH_FORMAT),
  },
  /**
   *  상품 주문 취소 상태 리스트
   */
  orderCancelStatusList: [],
  /**
   *  취소 접수자 리스트
   */
  cancelAcceptManagerList: [],
  /**
   *  취소 처리자 리스트
   */
  cancelManagerList: [],
  /**
   *  상세 검색
   */
  orderItemDetailSearch: {
    type: null,
    value: null,
  },
  /**
   *  상품 타입
   */
  productType: [],
  /**
   *  판매처
   */
  store: [],
};

/**
 *   취소 관리 리스트 필터 옵션 모델
 */
export const ORDER_CANCEL_MANAGEMENT_LIST_FILTER_OPTION_MODEL = {
  /**
   *  주문 타입
   */
  orderType: null,
  /**
   *  선물 상태
   */
  giftStatus: null,
};

/**
 *  취소 관리 모델
 */
export const ORDER_CANCEL_MANAGEMENT_MODEL = {
  /**
   *  선택된 상품 주문 취소 리스트
   */
  orderCancelManagementSelectedList: [],

  /**
   *  상품 주문 취소 리스트
   */
  orderCancelManagementList: {
    /**
     *  리스트
     */
    list: [],
    /**
     *  검색 박스
     */
    searchData: ORDER_CANCEL_MANAGEMENT_LIST_SEARCH_DATA_MODEL,
    /**
     *  검색 옵션
     */
    searchOption: ORDER_CANCEL_MANAGEMENT_LIST_SEARCH_OPTION_MODEL,
    /**
     *  필터 옵션
     */
    filterOption: ORDER_CANCEL_MANAGEMENT_LIST_FILTER_OPTION_MODEL,
    /**
     *  리스트 pagination
     */
    pagination: _LIST_PAGINATION_MODEL,
  },
};

/**
 *  반품 관리 리스트 검색 박스 모델
 */
export const ORDER_RETURN_MANAGEMENT_LIST_SEARCH_DATA_MODEL = {
  /**
   *  반품 요청 일시
   */
  returnRequestDate: {
    /**
     *  빠른 날짜 선택 값
     */
    quickDateIndex: 0,
    period: {
      startDate: setDateFormat(moment(), DATE_FORMAT.YMD_DASH_FORMAT),
      endDate: setDateFormat(moment(), DATE_FORMAT.YMD_DASH_FORMAT),
    },
  },
  /**
   *  상품 주문 반품 상태 리스트
   */
  orderReturnStatusList: [],
  /**
   *  반품 접수자 리스트
   */
  returnAcceptManagerList: [],
  /**
   *  상세 검색
   */
  orderItemDetailSearch: {
    type: null,
    value: null,
  },
  /**
   *  반품 사유 타입 리스트
   */
  returnReasonTypeList: [],
  /**
   *  상품 타입
   */
  productType: [],
  /**
   *  판매처
   */
  store: [],
};

/**
 *  반품 관리 리스트 검색 옵션 모델
 */
export const ORDER_RETURN_MANAGEMENT_LIST_SEARCH_OPTION_MODEL = {
  /**
   *  반품 요청 일시
   */
  returnRequestDate: {
    startDate: setDateFormat(moment(), DATE_FORMAT.YMD_DASH_FORMAT),
    endDate: setDateFormat(moment(), DATE_FORMAT.YMD_DASH_FORMAT),
  },
  /**
   *  상품 주문 반품 상태 리스트
   */
  orderReturnStatusList: [],
  /**
   *  반품 접수자 리스트
   */
  returnAcceptManagerList: [],
  /**
   *  상세 검색
   */
  orderItemDetailSearch: {
    type: null,
    value: null,
  },
  /**
   *  반품 사유 타입 리스트
   */
  returnReasonTypeList: [],
  /**
   *  상품 타입
   */
  productType: [],
  /**
   *  판매처
   */
  store: [],
};

/**
 *   반품 관리 리스트 필터 옵션 모델
 */
export const ORDER_RETURN_MANAGEMENT_LIST_FILTER_OPTION_MODEL = {
  /**
   *  주문 타입
   */
  orderType: null,
  /**
   *  선물 상태
   */
  giftStatus: null,
};

/**
 *  반품 관리 모델
 */
export const ORDER_RETURN_MANAGEMENT_MODEL = {
  /**
   *  선택된 상품 주문 반품 리스트
   */
  orderReturnManagementSelectedList: [],

  /**
   *  상품 주문 반품 리스트
   */
  orderReturnManagementList: {
    /**
     *  리스트
     */
    list: [],
    /**
     *  검색 박스
     */
    searchData: ORDER_RETURN_MANAGEMENT_LIST_SEARCH_DATA_MODEL,
    /**
     *  검색 옵션
     */
    searchOption: ORDER_RETURN_MANAGEMENT_LIST_SEARCH_OPTION_MODEL,
    /**
     *  필터 옵션
     */
    filterOption: ORDER_RETURN_MANAGEMENT_LIST_FILTER_OPTION_MODEL,
    /**
     *  리스트 pagination
     */
    pagination: _LIST_PAGINATION_MODEL,
  },
};

/**
 *  교환 관리 리스트 검색 박스 모델
 */
export const ORDER_EXCHANGE_MANAGEMENT_LIST_SEARCH_DATA_MODEL = {
  /**
   *  교환 요청 일시
   */
  exchangeRequestDate: {
    /**
     *  빠른 날짜 선택 값
     */
    quickDateIndex: 0,
    period: {
      startDate: setDateFormat(moment(), DATE_FORMAT.YMD_DASH_FORMAT),
      endDate: setDateFormat(moment(), DATE_FORMAT.YMD_DASH_FORMAT),
    },
  },
  /**
   *  상품 주문 교환 상태 리스트
   */
  orderExchangeStatusList: [],
  /**
   *  교환 접수자 리스트
   */
  exchangeAcceptManagerList: [],
  /**
   *  상세 검색
   */
  orderItemDetailSearch: {
    type: null,
    value: null,
  },
  /**
   *  교환 사유 타입 리스트
   */
  exchangeReasonTypeList: [],
  /**
   *  상품 타입
   */
  productType: [],
  /**
   *  판매처
   */
  store: [],
};

/**
 *  교환 관리 리스트 검색 옵션 모델
 */
export const ORDER_EXCHANGE_MANAGEMENT_LIST_SEARCH_OPTION_MODEL = {
  /**
   *  교환 요청 일시
   */
  exchangeRequestDate: {
    startDate: setDateFormat(moment(), DATE_FORMAT.YMD_DASH_FORMAT),
    endDate: setDateFormat(moment(), DATE_FORMAT.YMD_DASH_FORMAT),
  },
  /**
   *  상품 주문 교환 상태 리스트
   */
  orderExchangeStatusList: [],
  /**
   *  교환 접수자 리스트
   */
  exchangeAcceptManagerList: [],
  /**
   *  상세 검색
   */
  orderItemDetailSearch: {
    type: null,
    value: null,
  },
  /**
   *  교환 사유 타입 리스트
   */
  exchangeReasonTypeList: [],
  /**
   *  상품 타입
   */
  productType: [],
  /**
   *  판매처
   */
  store: [],
};

/**
 *   교환 관리 리스트 필터 옵션 모델
 */
export const ORDER_EXCHANGE_MANAGEMENT_LIST_FILTER_OPTION_MODEL = {
  /**
   *  주문 타입
   */
  orderType: null,
  /**
   *  선물 상태
   */
  giftStatus: null,
};

/**
 *  교환 관리 모델
 */
export const ORDER_EXCHANGE_MANAGEMENT_MODEL = {
  /**
   *  선택된 상품 주문 교환 리스트
   */
  orderExchangeManagementSelectedList: [],

  /**
   *  상품 주문 교환 리스트
   */
  orderExchangeManagementList: {
    /**
     *  리스트
     */
    list: [],
    /**
     *  검색 박스
     */
    searchData: ORDER_EXCHANGE_MANAGEMENT_LIST_SEARCH_DATA_MODEL,
    /**
     *  검색 옵션
     */
    searchOption: ORDER_EXCHANGE_MANAGEMENT_LIST_SEARCH_OPTION_MODEL,
    /**
     *  필터 옵션
     */
    filterOption: ORDER_EXCHANGE_MANAGEMENT_LIST_FILTER_OPTION_MODEL,
    /**
     *  리스트 pagination
     */
    pagination: _LIST_PAGINATION_MODEL,
  },
};
